import React from "react";
import { compose } from "redux";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DropdownItem } from "semantic-ui-react";
import { ActionMenu, ModalBuilder, Table } from "@redriver/cinnamon";
import {
  Targets,
  Actions,
} from "features/../../../shared/constants/permissions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { unlockSheet } from "../actions";

const UnlockSheet = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements", {
    keyPrefix: "SheetActions.UnlockSheet",
  });
  const { sheetId, sheetName } = sheet;
  // Auth checks done in SheetActions.js

  return (
    <ModalBuilder
      submitAction={unlockSheet}
      submitParams={{ sheetId, overwriteOtherUsers: true }}
      onSubmitted={onSubmitted}
      renderTrigger={(trigger) => (
        <DropdownItem onClick={trigger}>{t("TriggerText")}</DropdownItem>
      )}
      renderModal={(modalProps) => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header={t("HeaderText")}
          size="small"
        >
          {t("ConfirmMessage", { sheetName })}
        </TranslatedModal.Confirmation>
      )}
    />
  );
};

export default UnlockSheet;
